import PropTypes from 'prop-types';

import PlainTextCell from 'components/PlainTextCell';

type Props = {
  rowData: Pick<SentinelTeam, 'id' | 'scheduledForDeletionAt'>;
};

export default function IdCell({
  rowData: { id, scheduledForDeletionAt },
}: Props) {
  return (
    <PlainTextCell
      color={scheduledForDeletionAt ? 'alaskanHusky' : undefined}
      topLine={id}
    />
  );
}

IdCell.propTypes = {
  rowData: PropTypes.shape({
    id: PropTypes.string,
    scheduledForDeletionAt: PropTypes.string,
  }).isRequired,
};
